import { Button } from './form-fields/Button';
import { Checkbox } from './form-fields/Checkbox';
import { Checklist } from './form-fields/Checklist';
import { Default } from './form-fields/Default';
import { Datetime } from './form-fields/Datetime';
import { Group } from './form-fields/Group';
import { IFrame } from './form-fields/IFrame';
import { Image } from './form-fields/Image';
import { Numberfield } from './form-fields/Number';
import { Radio } from './form-fields/Radio';
import { Select } from './form-fields/Select';
import { Separator } from './form-fields/Separator';
import { Spacer } from './form-fields/Spacer';
import { DynamicList } from './form-fields/DynamicList';
import { Taglist } from './form-fields/Taglist';
import { Text } from './form-fields/Text';
import { Html } from './form-fields/Html';
import { ExpressionField } from './form-fields/ExpressionField';
import { Textfield } from './form-fields/Textfield';
import { Textarea } from './form-fields/Textarea';
import { Table } from './form-fields/Table';
import { FilePicker } from './form-fields/FilePicker';
import { DocumentPreview } from './form-fields/DocumentPreview';

import { Label } from './Label';
import { Description } from './Description';
import { Errors } from './Errors';
import { FormComponent } from './FormComponent';
import { FormField } from './FormField';

export { Label, Description, Errors };

export {
  Button,
  Checkbox,
  Checklist,
  Default,
  Datetime,
  FormComponent,
  FormField,
  Group,
  IFrame,
  DynamicList,
  Image,
  Numberfield,
  ExpressionField,
  Radio,
  Select,
  Separator,
  Spacer,
  Taglist,
  Text,
  Html,
  Textfield,
  Textarea,
  Table,
  FilePicker,
  DocumentPreview,
};

export const formFields = [
  /* Input */
  Textfield,
  Textarea,
  Numberfield,
  Datetime,
  ExpressionField,
  FilePicker,

  /* Selection */
  Checkbox,
  Checklist,
  Radio,
  Select,
  Taglist,

  /* Presentation */
  Text,
  Image,
  Table,
  Html,
  DocumentPreview,
  Spacer,
  Separator,

  /* Containers */
  Group,
  DynamicList,
  IFrame,

  /* Other */
  Button,
  Default,
];

export * from './icons';
export * from './Sanitizer';
export * from './util/domUtil';
export * from './util/sanitizerUtil';
